import { Location, Range } from 'slate';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';

export const locationInCharacterLimitRange = (
  editor: BufferEditor,
  location?: Location
): boolean => {
  const characterLimitRange = editor.decorateRanges?.[0];
  if (characterLimitRange && location) {
    return Range.includes(characterLimitRange, location);
  }
  return false;
};
